import React from "react";
import { connect } from "react-redux";

import { openModal } from "../../../../actions/shared/uiActions.js";
import Button from "../Button";

import AvatarEditorModal from "./AvatarEditorModal";
import { MAX_FILE_SIZE } from '../../../../util/uploadHelpers'


class AvatarEditorButton extends React.Component {
  render() {
    return (
      <div style={this.props.style}>
        <Button
          disabled={this.props.disabled}
          color="blue"
          variant="secondary"
          onClick={() => this.props.openAvatarEditorModal(this.props)}
          data-cy="avatar-editor-button"
        >
          {this.props.buttonText}
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  openAvatarEditorModal: props => dispatch(openModal(<AvatarEditorModal {...{
    maxSize: MAX_FILE_SIZE, ...props}
  } />))
});

export default connect(
  null,
  mapDispatchToProps
)(AvatarEditorButton);
